import Contact from "pages/Contact";
import Terms from "pages/Terms";
import { createBrowserRouter } from "react-router-dom";
import ConfirmSignup from "../pages/ConfirmSignup";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import ResendConfirmation from "../pages/ResendConfirmation";
import RequireAuth from "../components/RequireAuth";
import { GlobalLayout } from "@/Layouts/GlobalLayout";
import Home from "../pages/Home";
import ShipDetails from "../pages/ship/ShipDetails";
import StudyDetails from "@/pages/study/StudyDetails";
import NotFound from "@/errors/NotFound";
import ShipStepper from "@/pages/ship/ShipStepper";
import StudyStepper from "@/pages/study/StudyStepper";

export const router = createBrowserRouter([
  {
    path: "/signin",
    element: <SignIn />,
  },
  {
    path: "/signup",
    element: <SignUp />,
  },
  {
    path: "/",
    element: (
      <RequireAuth>
        <GlobalLayout />
      </RequireAuth>
    ),
    children: [
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/terms",
        element: <Terms />,
      },
      {
        path: "/confirm-signup",
        element: <ConfirmSignup />,
      },
      {
        path: "/resend-confirmation",
        element: <ResendConfirmation />,
      },
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/add-ship-generic",
        element: <ShipStepper />,
      },
      {
        path: "/add-study",
        element: <StudyStepper />,
      },
      {
        path: "/ship-details",
        element: <ShipDetails />,
      },
      {
        path: "/study-details/:id",
        element: <StudyDetails />,
      },
    ],
  },
  { path: "*", element: <NotFound /> },
]);
